import React from 'react';
import { Moon, Trophy, Star, TrendingUp } from 'lucide-react';
import { Input } from '../components/ui/input';
import { Textarea } from '../components/ui/textarea';
import { Slider } from '../components/ui/slider';

export const EveningReflection = ({ data, onUpdate }) => {
  const ratingEmojis = ['💀', '😫', '😔', '😐', '🙂', '😊', '😄', '🤩', '💪', '🔥'];

  return (
    <div className="space-y-6" data-testid="evening-reflection-section">
      {/* Bedtime */}
      <div className="glass-card p-6">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-10 h-10 rounded-xl bg-purple-500/20 flex items-center justify-center">
            <Moon className="w-5 h-5 text-purple-400" />
          </div>
          <div>
            <h3 className="font-semibold text-white">Bedtime</h3>
            <p className="text-xs text-white/50">When are you going to sleep?</p>
          </div>
        </div>
        <Input
          type="time"
          value={data.bedTime || ''}
          onChange={(e) => onUpdate({ bedTime: e.target.value })}
          className="input-futuristic font-mono text-xl"
          data-testid="bedtime-input"
        />
      </div>

      {/* What are you proud of? */}
      <div className="glass-card p-6">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-10 h-10 rounded-xl bg-amber-400/20 flex items-center justify-center">
            <Trophy className="w-5 h-5 text-amber-400" />
          </div>
          <div>
            <h3 className="font-semibold text-white">What are you proud of today?</h3>
            <p className="text-xs text-white/50">Celebrate your wins, big or small</p>
          </div>
        </div>
        <Textarea
          value={data.proudOf || ''}
          onChange={(e) => onUpdate({ proudOf: e.target.value })}
          placeholder="Today I'm proud of..."
          className="input-futuristic min-h-32 resize-none"
          data-testid="proud-of-input"
        />
      </div>

      {/* Rate Your Day */}
      <div className="glass-card p-6">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-10 h-10 rounded-xl bg-cyan-400/20 flex items-center justify-center">
            <Star className="w-5 h-5 text-cyan-400" />
          </div>
          <div>
            <h3 className="font-semibold text-white">Rate Your Day</h3>
            <p className="text-xs text-white/50">How did today go overall?</p>
          </div>
        </div>
        <div className="space-y-4">
          <div className="flex justify-between items-center">
            <span className="text-5xl">{ratingEmojis[(data.dayRating || 5) - 1]}</span>
            <div className="text-right">
              <span className="font-mono text-4xl text-cyan-400 neon-text">{data.dayRating || 5}</span>
              <span className="text-white/50 text-xl">/10</span>
            </div>
          </div>
          <Slider
            value={[data.dayRating || 5]}
            onValueChange={([value]) => onUpdate({ dayRating: value })}
            min={1}
            max={10}
            step={1}
            className="py-2"
            data-testid="day-rating-slider"
          />
          <div className="flex justify-between text-xs text-white/30">
            <span>Terrible</span>
            <span>Average</span>
            <span>Amazing</span>
          </div>
        </div>
      </div>

      {/* What will you improve tomorrow? */}
      <div className="glass-card p-6">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-10 h-10 rounded-xl bg-lime-400/20 flex items-center justify-center">
            <TrendingUp className="w-5 h-5 text-lime-400" />
          </div>
          <div>
            <h3 className="font-semibold text-white">What will you improve tomorrow?</h3>
            <p className="text-xs text-white/50">Set yourself up for growth</p>
          </div>
        </div>
        <Textarea
          value={data.improveTomorrow || ''}
          onChange={(e) => onUpdate({ improveTomorrow: e.target.value })}
          placeholder="Tomorrow I will improve..."
          className="input-futuristic min-h-32 resize-none"
          data-testid="improve-tomorrow-input"
        />
      </div>
    </div>
  );
};

export default EveningReflection;
